module.exports = __webpack_public_path__ + "static/media/YM42_1.4f0318ea.jpg";